"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useInStorePaymentForm_1 = require("../../hooks/useInStorePaymentForm");
var react_jsonschema_form_1 = require("react-jsonschema-form");
var core_1 = require("@material-ui/core");
var CustomComponentsMapper_1 = require("../../components/CustomComponentsMapper");
var ObjectFieldTemplate_1 = require("../objectFieldTemplate/ObjectFieldTemplate");
var MinimalLoader_1 = require("../../../../../common/components/presentation/MinimalLoader/MinimalLoader");
var ThemedErrorMessage_1 = require("../../../../../common/components/presentation/Error/ThemedErrorMessage");
var inStorePaymentFormStyles_1 = require("./inStorePaymentFormStyles");
var ButtonSubmit_1 = require("../../components/buttonSubmit/ButtonSubmit");
var useCustomErrorMessagesMapper_1 = require("../../hooks/useCustomErrorMessagesMapper");
var useSaveInStorePaymentForm_1 = require("../../hooks/useSaveInStorePaymentForm");
var useInStorePaymentFormValidate_1 = require("../../hooks/useInStorePaymentFormValidate");
var InStorePaymentForm = function () {
    var _a = useInStorePaymentForm_1.default(), formData = _a.formData, formSchema = _a.formSchema, uiSchema = _a.uiSchema, error = _a.error, handleFormChange = _a.handleFormChange, requiredFields = _a.requiredFields;
    var _b = useInStorePaymentFormValidate_1.default(), handleAsyncValidationErrors = _b.handleAsyncValidationErrors, resetAsyncErrors = _b.resetAsyncErrors, handleValidationErrors = _b.handleValidationErrors, asyncErrors = _b.asyncErrors, hasErrors = _b.hasErrors;
    var _c = useSaveInStorePaymentForm_1.default(handleAsyncValidationErrors), onSubmit = _c.onSubmit, isSubmitting = _c.isSubmitting;
    var styles = inStorePaymentFormStyles_1.default();
    var customWidgets = react_1.useMemo(function () { return CustomComponentsMapper_1.default(); }, []);
    var customErrorMessages = useCustomErrorMessagesMapper_1.default(formData);
    var onChange = react_1.useCallback(function (data) {
        resetAsyncErrors();
        handleFormChange(data.formData);
        handleValidationErrors(requiredFields, data);
    }, [resetAsyncErrors, handleFormChange, handleValidationErrors, requiredFields]);
    if (error) {
        return <ThemedErrorMessage_1.default fullPage={true} error={error}/>;
    }
    if (!formData || !formSchema || !uiSchema) {
        return <MinimalLoader_1.default />;
    }
    return (<core_1.Box className={styles.formWrapper} data-test="container:checkout:instorepayment_form">
      <react_jsonschema_form_1.default schema={formSchema} uiSchema={uiSchema} formData={formData} onChange={onChange} onSubmit={onSubmit} submitOnEnter={true} liveValidate transformErrors={customErrorMessages} extraErrors={asyncErrors} showErrorList={false} widgets={customWidgets} ObjectFieldTemplate={ObjectFieldTemplate_1.default}>
        <ButtonSubmit_1.default disabled={hasErrors || isSubmitting}/>
      </react_jsonschema_form_1.default>
    </core_1.Box>);
};
exports.default = InStorePaymentForm;
